@if (!buttonOnly) {
    <div class="flex flex-row center-center"
    >
        <mat-form-field class="flex cb-margin-right"
                        [ngClass]="{'cb-soft-required': softRequired && !required }">
            <mat-label>{{ label }}</mat-label>
            <input class="flex"
                   matInput
                   [name]="internalName"
                   [(ngModel)]="text"
                   [ignoreDirty]="ignoreDirty"
                   type="text"
                   [maxlength]="maxlength"
                   [required]="required"
                   [readOnly]="true"
                   [disabled]="disabled"
                   (click)="openSearchDialog()"
                   [ngClass]="{'pointer': cursorPointer}" />
        </mat-form-field>
        <button mat-icon-button
                class="cb-margin-right"
                [disabled]="disabled"
                (click)="openSearchDialog()">
            <mat-icon [title]="searchTooltip || 'Search ' + label + 's'">search</mat-icon>
        </button>
        @if (removeable) {
            <button mat-icon-button
                    (click)="clear()"
                    [disabled]="!text">
                <mat-icon title="Clear Selected {{label}}">remove_circle</mat-icon>
            </button>
        }
        <ng-content></ng-content>
    </div>
}
@if (buttonOnly) {
    <button mat-icon-button
            [disabled]="disabled"
            (click)="openSearchDialog()">
        <mat-icon [title]="searchTooltip || 'Search ' + label + 's'">search</mat-icon>
    </button>
}
